module.exports = __webpack_public_path__ + "img/kangmingjian_img1.78fefd7f.jpg";